import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/app/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: data
  })
}

// 验证码登录方法
export function loginByCode(phone,code, uuid) {
  const data = {
    phone,
    code,
    uuid
  }
  return request({
    url: '/app/loginByCode',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: data
  })
}

// 注册方法
export function register(username, password, phone, code, uuid) {
  const params = {
    username: username,
    password: password,
    phone: phone,
    code: code,
    uuid: uuid
  }
  return request({
    url: '/app/register',
    headers: {
      isToken: false,
      'Content-Type': 'application/json' // 强制用json
    },
    method: 'post',
    data: params
  })
}
// 发送验证码
export function sendSmsApi(phone) {
  return request({
    url: '/app/sendCode',
    method: 'get',
    params: {
      phone
    }
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 验证验证码
export function verifyCode(phone, code) {
  const params = {
    phone: phone,
    code: code,
  }
  return request({
    url: '/app/verifyCode',
    headers: {
      isToken: false,
      'Content-Type': 'application/json' // 强制用json
    },
    method: 'post',
    data: params
  })
}
// 重置密码
export function resetPaasword(phone, password) {
  return request({
    url: '/app/resetPassword',
    headers: {
      isToken: false,
    },
    method: 'get',
    params:{
      phone: phone,
      password: password,
    }
  })
}